import * as React from "react";
import { Avatar, Button, Dialog, Flex, FlexItem, Image, Grid, MenuButton, Pill, Popup, Text, Tooltip } from "@fluentui/react-northstar";
import { ExclamationTriangleIcon, EditIcon, MoreIcon, WindowRestoreIcon, CloseIcon, CallIcon, MentionIcon, ShieldKeyholeIcon, OpenOutsideIcon } from '@fluentui/react-icons-northstar';
import { Icon } from '@fluentui/react';
import { withTranslation, WithTranslation } from "react-i18next";
import { DateTimeParser } from "../../../helpers/date-time";
import StatusQueueConstants from "../../../constants/status-queue";
import Roles from "../../../constants/roles";
import LoaderInfinite from "../../loaders/loaderInfinite";

interface IListagemFilaProps extends WithTranslation {
    item: any,
    status: string,
    isScheduledQueue: boolean,
    getLabelStatusLocale: Function,
    onCancelCall: Function,
    validateCreateQueue: boolean,
    validateQueueErrorText: string,
    onValidateCreateQueue: any,
    startCall: Function,
    agendar: Function,
    authEnabled: boolean,
    govBrEnabled: boolean,
    filtered: boolean,
    internalAccessEnabled: boolean,
    role: string,
    isAdmin: boolean,
    pageSize: number,
    loadingInfinite: boolean,
}

const copyText = (props: any) => {
    let el = document.createElement('input');
    let queueUrl = window.location.origin + "/meeting-queue/" + props.Ancora;
    let urlParams = `?data=${window.btoa('{"queueId":"' + props.id + '", "assunto":"' + props.assunto + '", "ancora":"' + props.Ancora + '"}')}`;

    if (props.govBrEnabled) {
        queueUrl = window.location.origin + "/meeting-queue-auth/" + props.item.queue?.Ancora;
        urlParams = `?data=${window.btoa('{"requestId":"' + props.requestId + '", "assunto":"' + props.assunto + '", "ancora":"' + props.Ancora + '"}')}`;
    }

    el.style.position = 'fixed';
    el.style.left = '0';
    el.style.top = '0';
    el.style.opacity = '0';
    el.value = queueUrl + urlParams;
    document.body.appendChild(el);
    el.focus();
    el.select();

    document.execCommand("copy")
    document.body.removeChild(el);
}

const openBookings = () => {
    window.open("https://outlook.office.com/bookings/calendar", '_blank');
}

const ListagemFila: React.FunctionComponent<IListagemFilaProps> = props => {
    const localize = props.t;

    return (
        <Flex fill column>
            {!props.item.length ?
                <Flex hAlign="center" gap="gap.medium" styles={{ marginTop: '60px' }}>
                    <ExclamationTriangleIcon outline />
                    <Text size="small" weight="light" content={`${localize("NaoExistem")} ${props.status} ${localize("NestaUnidade")}`} />
                </Flex>
                :
                <Grid
                    columns={
                        ((props.authEnabled && props.govBrEnabled) || props.internalAccessEnabled) && props.isScheduledQueue ?
                            'minmax(200px, 320px) minmax(70px, 70px) 0.5fr 0.7fr 1fr 0.7fr 0.3fr' :
                            (((props.authEnabled && props.govBrEnabled) || props.internalAccessEnabled) && !props.isScheduledQueue ?
                                'minmax(200px, 320px) minmax(70px, 70px) 0.5fr 0.7fr 2fr 0.5fr' :
                                (props.isScheduledQueue ?
                                    'minmax(220px, 320px) minmax(70px, 70px) 0.5fr 1fr 0.7fr 0.3fr' :
                                    'minmax(220px, 320px) minmax(70px, 70px) 0.5fr 2fr 0.5fr'
                                ))
                    }>
                    <Flex gap="gap.small" className="header">
                        <FlexItem>
                            <Text content={localize("StatusAtendimento")} className="margin-style header-nome-serventia" />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip
                                trigger={<Icon className="margin-style info-icon" iconName="Info" />}
                                content={
                                    <React.Fragment>
                                        <Text content={`\u25CF ${localize("UsuarioNaFila")}`} />
                                        <br /><br />
                                        <Text content={`\u25CF ${localize("AtendimentoConfirmado")}`} />
                                        <br /><br />
                                        <Text content={`\u25CF ${localize("UsuarioEntrou")}`} />
                                    </React.Fragment>
                                }
                            />
                        </FlexItem>
                    </Flex>

                    <Flex gap="gap.small" className="header"></Flex>

                    <Flex gap="gap.small" className="header">
                        <FlexItem>
                            <Text className="margin-style" content={localize("Horario")} />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={localize("HorarioSolicitacao")} />
                        </FlexItem>
                    </Flex>

                    {((props.authEnabled && props.govBrEnabled) || props.internalAccessEnabled) &&
                        <Flex gap="gap.small" className="header">
                            <FlexItem>
                                <Text className="margin-style" content={`Solicitante`} />
                            </FlexItem>
                        </Flex>
                    }

                    <Flex gap="gap.small" className="header">
                        <FlexItem>
                            <Text className="margin-style" content={localize("Assunto")} />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={localize("AssuntoAtendimento")} />
                        </FlexItem>
                    </Flex>

                    {props.isScheduledQueue &&
                        <Flex gap="gap.small" className="header">
                            <FlexItem>
                                <Text className="margin-style" content={localize("Atendente")} />
                            </FlexItem>
                            <FlexItem>
                                <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={localize("Atendente")} />
                            </FlexItem>
                        </Flex>
                    }

                    <Flex gap="gap.small" className="header">
                        <FlexItem>
                            <Text className="margin-style" content={localize("Atendimento")} />
                        </FlexItem>
                        <FlexItem>
                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={localize("InformacoesAtendente")} />
                        </FlexItem>
                    </Flex>

                    {props.item.map((item: any, index: number) => {
                        let queue = item?.queue;

                        return (
                            <React.Fragment key={index}>
                                <Flex gap="gap.medium" vAlign="center" className={queue?.isSelected ? "row row-active" : "row"}>
                                    <FlexItem>
                                        {queue?.status == StatusQueueConstants.atendimentoAgendado ?
                                            <Flex vAlign="center" gap="gap.small">
                                                <Text
                                                    styles={{ marginLeft: '3.5rem' }}
                                                    content={`#${queue?.id.substr(queue?.id.length - 6)} ${props.getLabelStatusLocale(queue?.status)}`}
                                                />
                                                <Tooltip
                                                    trigger={
                                                        <Icon className="margin-style info-icon" iconName="Info" />
                                                    }
                                                    content={`Atender em até 30 minutos do horário de agendamento`}
                                                    position="after"
                                                    align="center"
                                                />
                                            </Flex>
                                            :
                                            <Text
                                                styles={{ marginLeft: '3.5rem' }}
                                                content={`#${queue?.id.substr(queue?.id.length - 6)} ${props.getLabelStatusLocale(queue?.status)}`}
                                            />
                                        }
                                    </FlexItem>
                                    {props.filtered &&
                                        <Pill
                                            size="small"
                                            appearance="outline"
                                            content={
                                                queue?.status == StatusQueueConstants.atendimentoAgendado ?
                                                    DateTimeParser.dateOffsetParser(queue?.Schedule?.date).format("DD/MM/YYYY") :
                                                    DateTimeParser.dateOffsetParser(queue?.updated).format("DD/MM/YYYY")
                                            }
                                        />
                                    }
                                </Flex>

                                {!props.isAdmin && props.role == Roles.leitor ?
                                    <Flex className={queue?.isSelected ? "row row-active" : "row"} />
                                    :
                                    <Flex gap="gap.medium" vAlign="center" className={queue?.isSelected ? "row row-active" : "row"}>
                                        <FlexItem>
                                            <MenuButton
                                                tabIndex={-1}
                                                trigger={<Button icon={<MoreIcon />} iconOnly text />}
                                                on="click"
                                                menu={[
                                                    {
                                                        key: 'edit-schedule',
                                                        content: localize("Editar"),
                                                        icon: <EditIcon outline />,
                                                        onClick: () => props.agendar(queue?.id),
                                                        hidden: (queue?.status == StatusQueueConstants.naFila || queue?.status == StatusQueueConstants.atendimentoAgendado && queue?.bookingsId)
                                                    },
                                                    {
                                                        key: 'cancel',
                                                        content: localize("Cancelar"),
                                                        icon: <CloseIcon outline />,
                                                        onClick: () => props.onCancelCall(queue?.id),
                                                        hidden: queue?.bookingsId
                                                    },
                                                    {
                                                        key: 'bookings',
                                                        content: `Ver no bookings`,
                                                        icon: <OpenOutsideIcon outline />,
                                                        onClick: () => openBookings(),
                                                        hidden: !queue?.bookingsId
                                                    },
                                                    {
                                                        key: 'copy',
                                                        content: localize("CopiarURL"),
                                                        icon: <WindowRestoreIcon outline />,
                                                        onClick: () => copyText(item.queue),
                                                    },
                                                ]}
                                            />
                                        </FlexItem>
                                    </Flex>
                                }


                                <Flex gap="gap.medium" vAlign="center" className={queue?.isSelected ? "row row-active" : "row"}>
                                    {queue?.status == StatusQueueConstants.naFila && <Text content={DateTimeParser.dateOffsetParser(queue?.created).format("HH:mm")} />}
                                    {queue?.status == StatusQueueConstants.atendimentoAgendado && <Text content={DateTimeParser.dateOffsetParser(queue?.Schedule?.date).format("HH:mm")} />}
                                </Flex>

                                {((props.authEnabled && props.govBrEnabled) || props.internalAccessEnabled) &&
                                    <Flex gap="gap.medium" vAlign="center" className="row">
                                        <Popup
                                            trigger={
                                                <Flex gap="gap.small" vAlign="center">
                                                    {queue?.UserProfile?.userPhoto &&
                                                        <Avatar
                                                            image={`data:image/jpeg;base64,${queue?.UserProfile?.userPhoto}`}
                                                            size="small"
                                                        />
                                                    }
                                                    {(queue?.UserProfile?.userPhoto == null && queue?.UserProfile?.userName) &&
                                                        <Flex gap="gap.smaller">
                                                            <Avatar size="small" name={queue?.UserProfile?.userName} />
                                                        </Flex>
                                                    }

                                                    <Text content={queue?.UserProfile?.userName} />
                                                </Flex>
                                            }
                                            on="hover"
                                            content={
                                                <Flex gap="gap.medium" vAlign="center" column>
                                                    <Flex gap="gap.medium" vAlign="center">
                                                        {queue?.UserProfile?.userPhoto &&
                                                            <Flex hAlign="center" gap="gap.small" column>
                                                                <Avatar
                                                                    image={`data:image/jpeg;base64,${queue?.UserProfile?.userPhoto}`}
                                                                    size="larger"
                                                                />
                                                                <Image width="45" src="/images/gov-br.svg" />
                                                            </Flex>
                                                        }
                                                        {queue?.UserProfile?.userPhoto == null &&
                                                            <Flex gap="gap.smaller">
                                                                <Avatar size="small" name={queue?.UserProfile?.userName} />
                                                            </Flex>
                                                        }
                                                        <Flex hAlign="start" gap="gap.smaller" column>
                                                            <Text weight="semibold" content={queue?.UserProfile?.userName} />

                                                            {queue?.UserProfile?.userLogin && 
                                                                <Flex vAlign="center" gap="gap.smaller">
                                                                    <ShieldKeyholeIcon size="smaller" outline />
                                                                    <Text weight="light" size="smaller" content={queue?.UserProfile?.userLogin} />
                                                                </Flex>
                                                            }
                                                            <Flex vAlign="center" gap="gap.smaller">
                                                                <MentionIcon size="smaller" outline />
                                                                <Text weight="light" size="smaller" content={queue?.UserProfile?.email} />
                                                            </Flex>
                                                            {queue?.UserProfile?.phoneNumber &&
                                                                <Flex vAlign="center" gap="gap.smaller">
                                                                    <CallIcon size="smaller" outline />
                                                                    <Text weight="light" size="smaller" content={queue?.UserProfile?.phoneNumber} />
                                                                </Flex>
                                                            }
                                                        </Flex>
                                                    </Flex>
                                                </Flex>
                                            }
                                        />
                                    </Flex>
                                }

                                <Flex gap="gap.medium" vAlign="center" className={queue?.isSelected ? "row row-active" : "row"}>
                                    <Text content={queue?.assunto} />
                                </Flex>

                                <Dialog
                                    open={!props.validateCreateQueue}
                                    onConfirm={props.onValidateCreateQueue}
                                    confirmButton="Ok"
                                    content={props.validateQueueErrorText}
                                    header={localize("AtenderEstaSolicitacao")}
                                />

                                {props.isScheduledQueue &&
                                    <Flex gap="gap.smaller" vAlign="center" hAlign="start" className={queue?.isSelected ? "row row-active" : "row"}>
                                        {queue?.Schedule?.attendants?.length > 0 &&
                                            <React.Fragment>
                                                <Flex gap="gap.smaller">
                                                    <Avatar size="small" name={queue?.Schedule?.attendants[0].name} />
                                                </Flex>

                                                <Flex vAlign="center" gap="gap.large">
                                                    <Text content={queue?.Schedule?.attendants[0].name} />
                                                </Flex>
                                            </React.Fragment>
                                        }
                                    </Flex>
                                }

                                {!props.isAdmin && props.role == Roles.leitor ?
                                    <Flex className={queue?.isSelected ? "row row-active" : "row"} />
                                    :
                                    <Flex gap="gap.medium" vAlign="center" className={queue?.isSelected ? "row row-active" : "row"}>
                                        {(queue?.status == StatusQueueConstants.atendimentoAgendado && item.scheduleDay && item.scheduleDayInRange) ||
                                            queue?.status == StatusQueueConstants.naFila ?
                                            <FlexItem>
                                                <Button
                                                    content={localize("Atender")}
                                                    loading={queue.loadingMeeting}
                                                    iconPosition="after"
                                                    onClick={() => props.startCall(queue)}
                                                    primary={queue.loadingMeeting ? false : true}
                                                    className={queue.loadingMeeting ? "readonly" : ""}
                                                />
                                            </FlexItem>
                                            : (queue?.status == StatusQueueConstants.atendimentoAgendado && item.scheduleDay && !item.scheduleDayInRange) ?
                                                <FlexItem>
                                                    <Tooltip
                                                        trigger={
                                                            <Flex>
                                                                <Button
                                                                    disabled
                                                                    content={localize("Atender")}
                                                                    iconPosition="after"
                                                                />
                                                            </Flex>
                                                        }
                                                        content={`O atendimento poderá ser iniciado 30 minutos antes do horário de agendamento`}
                                                        position="before"
                                                        align="center"
                                                    />
                                                </FlexItem>
                                                :
                                                <FlexItem>
                                                    <Tooltip
                                                        trigger={
                                                            <Flex>
                                                                <Button
                                                                    disabled
                                                                    content={localize("Atender")}
                                                                    iconPosition="after"
                                                                />
                                                            </Flex>
                                                        }
                                                        content={`Não é possível iniciar atendimentos futuros`}
                                                        position="before"
                                                        align="center"
                                                    />
                                                </FlexItem>
                                        }

                                    </Flex>
                                }
                            </React.Fragment>
                        );
                    })}
                </Grid>
            }

            {(props.loadingInfinite && props.item.length >= props.pageSize) && <LoaderInfinite />}
        </Flex>
    );
};

const listagemFilaWithTranslation = withTranslation()(ListagemFila);
export default listagemFilaWithTranslation;